/* eslint-disable class-methods-use-this */
import Axios from "axios";
import { ReactNode } from "react";
import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { SearchResultGroupInterface } from "../interface/search-result-interface";
import { MapboxLocationResult, MapboxSearchResultOptions, MapboxSearchType, SearchResultType } from "../types/types";

export class MapboxSearchResult extends SearchResultGroupInterface<MapboxLocationResult> {
    constructor(name: string, type: SearchResultType, icon: ReactNode, onResultClicked: (result: MapboxLocationResult) => void, options: MapboxSearchResultOptions) {
        super(name, type, icon, onResultClicked);
        this.limit = options.limit;
        this.mapboxSearchApiUrl = options.mapboxSearchApiUrl;
        this.types = options.types;
        this.getMapPosition = options.getMapPosition;
    }

    private readonly mapboxSearchApiUrl: string;

    private readonly mapboxSearchKey = "pk.eyJ1Ijoiam9lY3VzZGluIiwiYSI6ImNqYmNibGR1aTE0djkyeHBiNG03aWM2OHAifQ.xxvgx0NosHRcDtaOAE-CFQ";

    private readonly types: MapboxSearchType[];

    private readonly limit: number;

    private readonly getMapPosition: () => [number, number];

    private createSearchParams() {
        return {
            // eslint-disable-next-line camelcase
            access_token: this.mapboxSearchKey,
            limit: this.limit,
            types: this.types.join(","),
            proximity: this.getMapPosition().join(","),
        };
    }

    public async getResults(searchString: string): Promise<{ type: SearchResultType; results: SearchResult<MapboxLocationResult>[] }> {
        const response = await Axios.get(`${this.mapboxSearchApiUrl}/${searchString}.json`, { params: this.createSearchParams() });
        // Response is a set of features, need to parse them to our SearchResult type
        const parsedResponse: SearchResult<MapboxLocationResult>[] = response.data.features.map((feature) => ({
            displayText: feature.place_name,
            result: { id: feature.id, name: feature.place_name, bounds: feature.bbox ?? feature.center },
        }));
        return { type: this.type, results: parsedResponse };
    }
}
